import { MapV2Button, MapV2ButtonProps } from 'components/mapV2/elements/MapV2Button';
import styled from 'styled-components/macro';

type ButtonsProps = MapV2ButtonProps & { id: string };

interface Props {
    className?: string;
    buttons: ButtonsProps[];
}

export const ContentButtons = (props: Props): JSX.Element => {
    return (
        <S_ContentButtons className={props.className}>
            {props.buttons.map((button) => {
                return <MapV2Button key={button.id} {...button} />;
            })}
        </S_ContentButtons>
    );
};

const S_ContentButtons = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 0 20px;
`;
